// angular
import {
    Component,
    OnInit,
    OnChanges,
    ViewChild,
    Input,
    EventEmitter,
    Output,
    SimpleChanges,
    OnDestroy, ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// services
import { AuthService } from '../../../core/auth.service';
import { BaseService } from '../../../shared/base.service';
// others
import { BaseComponent } from '../../../shared/base.component';
import { AppService } from '../../../app.service';
import { PatientService } from '../../patient.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { PatientsService } from '../../../patients/patients.service';
import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import * as moment from 'moment';

@Component({
    selector: 'comparison-map-component',
    templateUrl: 'comparison-map.component.html',
    styleUrls: ['comparison-map.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        PatientsService,
        BaseService
    ]
})

export class ComparisonMapComponent extends BaseComponent implements OnChanges {

    @Input() isCollapsed: boolean;
    @Input() selectedCurrentId: number;
    @Input() selectedCurrentDate: string;
    @Input() symptomMapType: string;
    @Input() comparisonDates: Array<any>; // Structured diagnosis items, to be used in tree-selector.
    @Input() graphicData : Array<any>;
    @Input() comparisonData : any;

    @Output() updateMap = new EventEmitter();
    @Output() drawMap = new EventEmitter();
    @Output() filterComparison = new EventEmitter();

    @ViewChild('ps', { static: false }) ps: PerfectScrollbarComponent;

    selectedComparisonId: number;
    selectedComparisonDate: string;
    formatSelectedCurrentDate: string;
    selectedComparisonType: string;
    filteredData : Array<any> = [];
    filtered = {
        increased: false,
        new: false,
        reduced: false
    }

    isCriteriaCollapsed : Object[] = [];

    TYPES = {
        new_appearance: 'new-appearance',
        negative_change: 'negative-change',
        no_change: 'no-change',
        positive_change: 'positive-change',
        hide_on_map: 'hide-on-map'
    };

    constructor(
        public authService: AuthService,
        public baseService: BaseService,
        public router: Router,
        public appService: AppService,
        public route: ActivatedRoute,
        public patientService: PatientService,
        public translate: TranslateService,
        public patientsService : PatientsService
    ) {
        super(authService, router, baseService, appService);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['graphicData'] && changes['graphicData'].currentValue) {
            this.filtered = {
                increased: false,
                new: false,
                reduced: false
            };
            this.filterComparison.emit(this.filtered);
            this.getFilteredData();
        }
        if (changes['selectedCurrentDate']) {
            this.formatSelectedCurrentDate = moment(this.selectedCurrentDate, 'DD.MM.YYYY').format('DD.MM.YY');
        }
    }

    get completedDates() {
        return this.comparisonDates.filter((item) => {
            return (item.sr_id <= this.selectedCurrentId || item.di_id <= this.selectedCurrentId);
        });
    }

    getFilteredData() {
        this.filteredData = [];
        this.graphicData.forEach(domain => {
            const filteredSymtom = domain.filter(symptom => {
                if (symptom.type === this.TYPES.no_change) {
                    return false;
                }
                if (!this.filtered.increased && !this.filtered.new && !this.filtered.reduced) {
                    return true;
                }
                return (this.filtered.increased && symptom.type === this.TYPES.negative_change)
                    || (this.filtered.new && symptom.type === this.TYPES.new_appearance)
                    || (this.filtered.reduced && symptom.type === this.TYPES.positive_change);
            });

            if (filteredSymtom.length > 0) {
                this.filteredData.push(filteredSymtom);
            }
        });
    }

    filter() {
        this.getFilteredData();
        this.filterComparison.emit(this.filtered);
    }

    selectDate(id, date, type) {
        this.selectedComparisonId = id;
        this.selectedComparisonDate = moment(date, 'DD.MM.YYYY').format('DD.MM.YY');
        this.selectedComparisonType = type;
        this.drawMap.emit(this.selectedComparisonId);
    }

    collapseDomain(name) {
        this.isCriteriaCollapsed[name] = !this.isCriteriaCollapsed[name];
    }
}
